var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRentsuccessMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5839 61.5071L8.89605 33.9531C6.87886 31.9358 5.76562 29.2446 5.76562 26.3797C5.76562 23.5253 6.87043 20.8446 8.87519 18.8251C8.41064 15.5961 9.41931 12.1935 11.8968 9.7137C11.9009 9.70956 11.9052 9.70527 11.9093 9.69899C11.4615 6.48051 12.4702 3.0966 14.9393 0.627278C15.7763 -0.209735 17.1324 -0.207735 17.9693 0.625135L37.3001 19.9111C37.9279 20.541 56.8949 38.2513 56.5308 39.0653C56.1626 39.8815 55.7641 42.4527 54.8686 42.39C50.5035 42.1263 57.9069 50.159 54.8686 53.1953C51.8301 56.2297 47.9433 50.5257 48.2196 54.8577C48.274 55.7491 46.5423 59.4784 45.7262 59.8447C44.9381 60.2036 37.2261 62.1527 36.5839 61.5071Z",
    fill: "url(#paint0_linear_5168_448)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7752 67.3939C43.9085 67.3939 41.2175 66.2806 39.196 64.2591L32.0019 57.1043C31.37 56.4744 31.1942 55.5201 31.5584 54.7061C31.9266 53.8921 32.7553 53.4128 33.6467 53.4464C37.9406 53.7268 42.2051 52.1364 45.2393 49.0999C48.2777 46.0634 49.8638 41.8384 49.5875 37.5066C49.5331 36.6152 50.031 35.7843 50.843 35.4181C51.6591 35.0477 52.5787 34.2796 53.2063 34.9094L72.5258 55.1876C73.3628 56.0246 73.3628 57.3807 72.5258 58.2156C70.0608 60.6829 66.7044 61.7041 63.4525 61.2458C63.4484 61.2499 63.4441 61.2542 63.44 61.2584C60.9624 63.734 57.5851 64.749 54.3291 64.2823C52.3121 66.289 49.6336 67.3939 46.7752 67.3939Z",
    fill: "url(#paint1_linear_5168_448)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 9.72916,
    y: 13.6329,
    width: 49.7685,
    height: 49.7587
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.81px)",
      clipPath: "url(#bgblur_0_5168_448_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5168_448)",
    "data-figma-bg-blur-radius": 5.62625
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9887 52.1353C13.4392 44.5853 13.5162 32.3518 20.9887 24.8909C28.3962 17.4749 40.6332 17.2895 48.2292 24.8909C56.6968 33.3591 54.7445 45.6266 48.2292 52.1353C40.8449 59.5202 28.6205 59.7628 20.9887 52.1353Z",
    fill: "#BCE4F1",
    fillOpacity: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.627719 72.5167C-0.20924 71.6797 -0.20924 70.3235 0.627719 69.4865L13.7699 56.3435C14.6069 55.5065 15.963 55.5065 16.7999 56.3435C17.6369 57.1805 17.6369 58.5367 16.7999 59.3737L3.65771 72.5167C2.82061 73.3537 1.46468 73.3537 0.627719 72.5167Z",
    fill: "url(#paint2_linear_5168_448)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4602 72.5234C12.6232 71.6864 12.6232 70.3302 13.4602 69.4932L22.3169 60.636C23.1538 59.799 24.5099 59.799 25.3469 60.636C26.1838 61.473 26.1838 62.8291 25.3469 63.6662L16.4902 72.5234C15.6531 73.3604 14.2971 73.3604 13.4602 72.5234Z",
    fill: "url(#paint3_linear_5168_448)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.627719 59.6585C-0.20924 58.8215 -0.20924 57.4654 0.627719 56.6284L9.48442 47.7711C10.3214 46.9341 11.6775 46.9341 12.5144 47.7711C13.3514 48.6081 13.3514 49.9643 12.5144 50.8013L3.65771 59.6585C2.82061 60.4956 1.46468 60.4956 0.627719 59.6585Z",
    fill: "url(#paint4_linear_5168_448)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3348 29.7748C42.6536 29.0936 41.55 29.0936 40.8689 29.7748L39.3863 31.2585C37.4453 30.3432 35.0714 30.6406 33.4712 32.2409C32.4835 33.2287 31.9385 34.5435 31.9385 35.9417C31.9385 37.3382 32.4835 38.6529 33.4712 39.6407C34.1523 40.3203 34.1523 41.4272 33.4712 42.1068C32.79 42.7879 31.6864 42.7879 31.0053 42.1068C30.6749 41.7763 30.4943 41.3387 30.4943 40.8738C30.4943 39.9098 29.7144 39.1298 28.7505 39.1298C27.7866 39.1298 27.0067 39.9098 27.0067 40.8738C27.0067 41.6651 27.1993 42.4215 27.5305 43.1157L26.0734 44.5729C25.3922 45.2541 25.3922 46.3578 26.0734 47.039C26.7545 47.7202 27.858 47.7203 28.5393 47.039L30.0216 45.5565C32.2782 46.6202 34.5178 45.9945 35.9368 44.5731C37.8067 42.7031 37.8776 39.8018 36.3202 37.7527C36.2351 37.5424 36.1074 37.3454 35.9368 37.175C35.2567 36.4949 35.2533 35.3926 35.9368 34.7089C36.618 34.0311 37.7216 34.0294 38.4027 34.7107C38.7331 35.0376 38.9137 35.4753 38.9137 35.942C38.9137 36.906 39.6936 37.686 40.6575 37.686C41.6214 37.686 42.4013 36.906 42.4013 35.942C42.4013 35.1492 42.2089 34.3925 41.8781 33.6988L43.3345 32.2412C44.0159 31.5596 44.0159 30.4544 43.3348 29.7748Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5168_448",
    x: 9.72916,
    y: 13.6329,
    width: 49.7685,
    height: 49.7587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.281312,
    dy: 0.140656
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.703281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5168_448"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5168_448_clip_path",
    transform: "translate(-9.72916 -13.6329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9887 52.1353C13.4392 44.5853 13.5162 32.3518 20.9887 24.8909C28.3962 17.4749 40.6332 17.2895 48.2292 24.8909C56.6968 33.3591 54.7445 45.6266 48.2292 52.1353C40.8449 59.5202 28.6205 59.7628 20.9887 52.1353Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5168_448",
    x1: 39.4596,
    y1: 0,
    x2: 39.4596,
    y2: 67.3939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE78FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5168_448",
    x1: 39.4596,
    y1: 0,
    x2: 39.4596,
    y2: 67.3939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE78FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5168_448",
    x1: 8.71382,
    y1: 55.7157,
    x2: 8.71382,
    y2: 73.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE78FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5168_448",
    x1: 19.4035,
    y1: 60.0082,
    x2: 19.4035,
    y2: 73.1512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE78FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5168_448",
    x1: 6.57106,
    y1: 47.1433,
    x2: 6.57106,
    y2: 60.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE78FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentsuccessMark);
export default __webpack_public_path__ + "static/media/rentsuccess_mark.1ccf6b18f229109ecfa29dd3b5d97b91.svg";
export { ForwardRef as ReactComponent };